export default "__VITE_ASSET__989dcf38__"